<template>
  <b-modal
    id="modal-danger"
    v-model="modalShow"
    ok-variant="danger"
    ok-title="Add"
    modal-class="modal-normal"
    centered>
    <div class="d-block text-center mb-1">
      <p class="font-weight-bold h2">
        Update Category
      </p>
    </div>
    <ValidationObserver
      ref="CategoryForm"
      tag="form">
      <b-row class="align-items-end">
        <b-col>
          <TextFieldInput
            v-model="category.level"
            :rules="{ required: true }"
            disabled
            name="Level"
            label="Level"
            trim />
        </b-col>
      </b-row>
      <b-row class="align-items-end">
        <b-col>
          <TextFieldInput
            v-model="category.name"
            :rules="{required: true}"
            name="Category Name"
            label="Category Name"
            placeholder="Input Category Name"
            trim />
        </b-col>
      </b-row>
      <b-row class="align-items-end">
        <b-col>
          <TextFieldInput
            v-model.number="category.resolvedDay"
            :rules="{
              required: true,
              min_value: 0,
              numeric: true
            }"
            name="Resolved Day"
            label="Resolved Day"
            placeholder="Input Resolved Day"
            trim
            @keypress="$keypressNumberNoDecimal()" />
        </b-col>
      </b-row>
      <b-row class="align-items-end">
        <b-col>
          <TextFieldInput
            v-model.number="category.resolvedHour"
            :rules="{
              numeric: true,
              required: true,
              between: [0, 23] }"
            name="Resolved Hour"
            label="Resolved Hour"
            placeholder="Input Resolved Hour"
            trim
            @keypress="$keypressNumberNoDecimal()" />
        </b-col>
      </b-row>
      <b-row class="align-items-end">
        <b-col>
          <TextFieldInput
            v-model.number="category.resolvedMin"
            :rules="{
              numeric: true,
              required: true,
              between: [0, 59] }"
            name="Resolved Min"
            label="Resolved Min"
            placeholder="Input Resolved Min"
            trim
            type="number"
            @keypress="$keypressNumberNoDecimal()" />
        </b-col>
      </b-row>
      <b-row class="align-items-end">
        <b-col>
          <SelectField
            v-model="category.priority"
            :options="categoriesEnum"
            name="Priority"
            form-label="Priority"
            label-option="label"
            :rules="{
              required: true,
            }"
            return-value="value" />
        </b-col>
      </b-row>
      <b-row class="align-items-end">
        <b-col>
          <SelectField
            v-model="category.urgency"
            :options="categoriesEnum"
            name="Urgency"
            form-label="Urgency"
            label-option="label"
            :rules="{
              required: true,
            }"
            return-value="value" />
        </b-col>
      </b-row>
      <b-row class="align-items-end">
        <b-col>
          <SelectField
            v-model="category.impact"
            :options="categoriesEnum"
            :rules="{
              required: true,
            }"
            name="Impact"
            form-label="Impact"
            label-option="label"
            return-value="value" />
        </b-col>
      </b-row>
      <b-row class="align-items-end">
        <b-col>
          <SelectField
            v-if="category.level === 1"
            v-model="category.visibelGroup"
            :close-on-select="false"
            :deselect-from-dropdown="true"
            multiple
            :options="groupService"
            name="Group"
            form-label="Group"
            label-option="name"
            return-value="id"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <StatusRadioButton :status.sync="category.status" />
        </b-col>
      </b-row>
    </ValidationObserver>
    <template #modal-footer="{ hide }">
      <div class="mx-auto">
        <b-button
          variant="primary"
          style="margin-right: 12px"
          @click="onUpdate()">
          Update
        </b-button>
        <b-button
          variant="outline-primary"
          @click="hide">
          Cancel
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import TextFieldInput from '@/components/Form/TextFieldInput.vue'
import SelectField from '@/components/Form/SelectField.vue'
import StatusRadioButton from '@/components/Form/StatusRadioButton.vue'

export default {
  components: {
    TextFieldInput,
    SelectField,
    StatusRadioButton
  },
  props: {
    value: {
      type: Boolean
    },
    initialCategory: {
      type: Object,
      required: true
    },
    selectedItem: {
      type: Object,
      required: true
    },
    groupService: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      categoriesEnum: [
        { label: 'low', value: 'low' },
        { label: 'medium', value: 'medium' },
        { label: 'high', value: 'high' }
      ],
      categories: {
        level: 1,
        name: '',
        parentId: 0,
        resolvedDay: '',
        resolvedHour: '',
        resolvedMin: '',
        priority: 'low',
        urgency: 'low',
        impact: 'low',
        visibelGroup: []
      }
    }
  },
  computed: {
    modalShow: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    category: {
      get () {
        return this.selectedItem
      },
      set (val) {
        this.$emit('update:selected-item', val)
      }
    }
  },
  methods: {
    async onUpdate () {
      const valid = await this.$refs.CategoryForm.validate()
      if (valid) {
        const payload = {
          id: this.category.id,
          name: this.category.name,
          resolvedDay: this.category.resolvedDay,
          resolvedHour: this.category.resolvedHour,
          resolvedMin: this.category.resolvedMin,
          parentId: this.category.parentId,
          priority: this.category.priority,
          urgency: this.category.urgency,
          impact: this.category.impact,
          status: this.category.status,
          visibelGroup: Array.isArray(this.category.visibelGroup)
            ? this.category.visibelGroup.filter((id) => id != null)
            : []
        }
        this.$emit('update-category', payload)
      }
    },
    resetForm () {
      this.category = { ...this.initialCategory }
      this.$refs.CategoryForm.reset()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
